import React from 'react';
import { Chip } from '@mui/material';

const TONES = {
  aprovado: 'success',
  success: 'success',
  pendente: 'warning',
  warning: 'warning',
  rejeitado: 'error',
  error: 'error',
  entrada: 'primary',
  saida: 'default',
  ativo: 'success',
  admin: 'primary',
  gerente: 'warning',
  funcionario: 'default',
};

export default function StatusChip({ status, label }) {
  const key = String(status || '').toLowerCase();
  const color = TONES[key] || 'default';
  return <Chip size="small" color={color} label={label || status || '—'} />;
}
